export default [{
  path: '/getDigitalSuccess',
  name: 'getDigitalSuccess',
  component: () => import('@/views/getDigitalSuccess/index'),
}]
